/** @jsx jsx */
import { jsx } from "@emotion/react";
import React, { useEffect, useRef, useState } from "react";
import PropsDynamicSvg from "../../types/PropsDynamicSvg";

const DynamicSvg = (props: PropsDynamicSvg) => {
  // destructure props
  const { name, cssObject, ...rest } = props;

  // use state to store whether the svg is still loading
  const [loading, setLoading] = useState(true);

  // use ref to store the imported svg
  const ImportedSvgRef =
    useRef<React.FC<React.SVGProps<SVGSVGElement>> | null>(null);

  // make an asynchronous function
  const importSvg = async () => {
    try {
      // use a dynamic import
      ImportedSvgRef.current =
        // the first part of the string (!svg-react-loader!) comes from here:
        // "svg-react-loader query parameters [...] can also be defined at the import level:   import Fork from "-!svg-react-loader?props[]=className:w-4 h-4!../components/Icons/Fork.inline.svg";"
        // this is not the same in every project, depends on the loader
        // the second part of the string (../../../static/svg/) is the relative path to the relevant folder
        // this would have to change according to directory hierarchy
        (
          await import(`!svg-react-loader!../../../static/svg/${name}.svg`)
        ).default;
    } catch (err) {
      // if not found, import the placeholder
      ImportedSvgRef.current = (
        await import(`!svg-react-loader!../../../static/svg/nexo.svg`)
      ).default;
    } finally {
      // once done, set loading to false
      setLoading(false);
    }
  };

  // run the function only on initial render
  useEffect(() => {
    importSvg();
  }, []);

  // if still loading, or no import, return null
  if (loading || !ImportedSvgRef.current) {
    return null;
  }

  // otherwise, return component
  else {
    const { current: ImportedSvg } = ImportedSvgRef;
    return <ImportedSvg css={cssObject} {...rest} />;
  }
};

export default DynamicSvg;
